"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialState = exports.buildAnswerPayload = void 0;
let allAnswers = [];
const initialState = {
    questionData: null,
    answers: [],
    currentQuestionIndex: -1,
    done: false,
    blockingText: '',
    errorText: '',
    sending: false,
    blockedQuestions: [],
    showConfirm: false,
};
exports.initialState = initialState;
const buildAnswerPayload = (questionsData, answersData, userId) => {
    allAnswers = answersData;
    const payload = {
        sessionId: questionsData.sessionId,
        donorId: userId,
        healthQuestionnaireId: questionsData.healthQuestionnaireId,
        siteDefinitionCode: questionsData.donationSiteDefinitionCode,
        questions: [],
        subQuestions: [],
        donationType: questionsData.donationType,
    };
    const mainQuestionAnswers = allAnswers.filter((a) => !a.parentId);
    processAnswerData(payload, mainQuestionAnswers, true);
    return payload.questions.length > 0 ? payload : null;
};
exports.buildAnswerPayload = buildAnswerPayload;
const appendSubQuestionAnswers = (payload, parentId) => {
    const subQuestionAnswers = allAnswers.filter((a) => a.parentId && a.parentId === parentId);
    if (subQuestionAnswers.length === 0) {
        return;
    }
    processAnswerData(payload, subQuestionAnswers);
};
const processAnswerData = (payload, answers, isMainQuestion = false) => {
    var _a;
    const propName = isMainQuestion ? 'questions' : 'subQuestions';
    for (const answerData of answers) {
        const answerPayload = createAnswer(answerData);
        (_a = payload[propName]) === null || _a === void 0 ? void 0 : _a.push(answerPayload);
        appendSubQuestionAnswers(answerPayload, answerData.id);
    }
};
const createAnswer = (answerData) => ({
    id: answerData.id,
    answer: {
        answer: answerData.answer,
        comment: `Answered to ${answerData.type}-question nr: ${answerData.questionNumber}\nid[${answerData.id}]`,
    },
    subQuestions: [],
});
